export class ConcatModel {
  email: number;
  message: string;
  user_name: string;
  phone_number: string;
}
